import { APP_MODULES } from 'constants/appModules';
import { MODULE_ROOT_PATHS, PATHS } from 'constants/paths';
import { getPathParamName } from 'helpers/PathHelper';
import { useMemo } from 'react';
import { matchPath } from 'react-router-dom';
export type SidebarRoute = {
  path: string;
  name: string;
  module: APP_MODULES;
  paramName?: string;
  queryParam?: string;
  rootPath?: string;
  isDisabled?: boolean;
  isHidden?: boolean;
};
type SidebarRoutesGroup = {
  name: string;
  isHidden?: boolean;
  routes: SidebarRoute[];
};
export const isRouteActive = (
  pathname: string,
  { rootPath, path }: { rootPath?: string; path: string },
) => !!matchPath(pathname, { path: rootPath ?? path });
export const useSidebarRoutes = ({
  tuwi,
  tightWellAccessible,
  currentWell,
}: {
  tuwi?: string;
  tightWellAccessible: boolean;
  currentWell: any;
}): SidebarRoutesGroup[] => {
  return useMemo(() => {
    return [
      {
        name: 'sidebar.routes.reporting',
        routes: [
          {
            path: PATHS.EDDR_OVERVIEW,
            module: APP_MODULES.EDDR,
            paramName: getPathParamName(PATHS.EDDR_OVERVIEW),
            name: `sidebar.routes.modules.${APP_MODULES.EDDR}`,
            rootPath: MODULE_ROOT_PATHS.EDDR,
            isDisabled: !tuwi || (currentWell && currentWell.tightWell && !tightWellAccessible),
          },
          {
            path: PATHS.LESSONS_LEARNT_REGISTER,
            module: APP_MODULES.LESSONS_LEARNT,
            name: `sidebar.routes.modules.${APP_MODULES.LESSONS_LEARNT}`,
          },
        ],
      },
    ];
  }, [tuwi, currentWell, tightWellAccessible]);
};
